import { useMemo } from 'react';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import PersonIcon from '@mui/icons-material/Person';
import SettingsIcon from '@mui/icons-material/Settings';
import { Outlet } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import DashboardLayout from './DashboardLayout';
import useAuthStore from '../store/authStore';
import { fetchParentStudents } from '../api/students';

const ParentLayout = () => {
  const { user } = useAuthStore();

  const { data } = useQuery({
    queryKey: ['parent-students', user?.id],
    queryFn: () => fetchParentStudents(user.id),
    enabled: Boolean(user?.id),
  });

  const navItems = useMemo(() => {
    const students = data || [];
    const items = [
      { label: 'Журнали', path: '/parent', icon: <MenuBookIcon />, exact: true },
    ];

    const uniqueTutors = [];
    const seenTutors = new Set();
    students.forEach((s) => {
      if (s.tutorId && !seenTutors.has(s.tutorId)) {
        seenTutors.add(s.tutorId);
        uniqueTutors.push({ id: s.tutorId, name: s.tutorName });
      }
    });

    if (uniqueTutors.length === 1) {
      items.push({
        label: 'Наш репетитор',
        path: `/parent/tutor/${uniqueTutors[0].id}`,
        icon: <PersonIcon />,
      });
    } else if (uniqueTutors.length > 1) {
      items.push({
        label: 'Наші репетитори',
        path: '/parent/tutors',
        icon: <PersonIcon />,
        exact: true,
      });
    }

    items.push({ label: 'Дані та конфіденційність', path: '/parent/settings', icon: <SettingsIcon /> });
    return items;
  }, [data]);

  return (
    <DashboardLayout navItems={navItems}>
      <Outlet />
    </DashboardLayout>
  );
};

export default ParentLayout;
